import { useContext } from "react";
// components
import AboutUs from "@/components/aboutUs/AboutUs";
import SEO from "@/components/seo/SEO";

// API
import { API, graphqlOperation } from "aws-amplify";
import { getMerchantDetails } from "@/graphql/queries";

//context
import MerchantContext from "@/contexts/MerchantContext";

const AboutUsScreen = () => {
  const merchantInfoContext = useContext(MerchantContext);

  return (
    <>
      <SEO title="About Us" keywords="" description="About Us" />
      <AboutUs info={merchantInfoContext} />
    </>
  );
};

export default AboutUsScreen;
